import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainRoutingModule } from './main-routing.module';
import { MainComponent } from './main.component';
import { AppNavbarModule } from '../../shared';
import { HomeModule } from '../home/home.module';
import { LoadingModule } from '@schoolbelle/common/loading';
import { PresenceIndicatorModule } from '../../shared/services/presence';

@NgModule({
  declarations: [MainComponent],
  imports: [
    CommonModule,
    MainRoutingModule,
    AppNavbarModule,
    LoadingModule.forRoot(),
    HomeModule,
    PresenceIndicatorModule,
  ],
})
export class MainModule {}
